
/**
 * @ENV
 */
export default {
    SCRIPT_ELEMENT: 'script[type="scoped"]',
    GLOBAL_BINDING_METHOD: 'bind',
    LOCAL_BINDING_METHOD: 'bind',
    SCRIPT_INERT_CONTEXTS: [],
};